import { useAppConfig } from '#/config/AppConfigContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { OAuthButton } from './OAuthButton';

type Props = {
  getUrl: () => string | Promise<string>;
};

export function GoogleOAuthButton({ getUrl }: Props) {
  const { appConfig } = useAppConfig();
  const { i18n } = useI18n();

  return (
    <OAuthButton
      imgSrc={getStaticImageSrc(
        'icons/social/google.svg',
        appConfig.idealist.staticImgPath,
      )}
      imgAlt="Google"
      text={i18n('Continue with Google')}
      getUrl={getUrl}
      qaId="google-oauth"
    />
  );
}
